import type { ApolloClient } from '@apollo/client';
import { GET_ORG_EMAIL_BY_ID } from '../../lib/graphql/queries/organizations';
import { previewEmail } from './previewEmail';

/**
 * Fetch a single email by message id and open it in the global email
 * preview modal. The email counterpart to fetchCallRecordById: feed rows
 * (e.g. the hot-leads lastFromRemi touch) hold only a messageId, so this
 * pulls the body/subject on click rather than carrying it in the list.
 * Returns false when org/messageId is missing or the email isn't found.
 */
export async function openEmailPreviewById(
  client: ApolloClient,
  organizationId: string | undefined,
  messageId: string | undefined | null,
): Promise<boolean> {
  if (!organizationId || !messageId) return false;
  const { data } = await client.query<{
    organization?: { messages?: { items?: Record<string, unknown>[] } } | null;
  }>({
    query: GET_ORG_EMAIL_BY_ID,
    variables: { organizationId, messageId },
    fetchPolicy: 'cache-first',
  });
  const item = data?.organization?.messages?.items?.[0];
  if (!item) return false;
  previewEmail({
    bodyHtml: (item.bodyHtml as string | null) ?? null,
    body: (item.body as string | null) ?? null,
    subject: item.subject as string | undefined,
    fromAddress: item.fromAddress as string | undefined,
    toAddress: item.toAddress as string | undefined,
    sentAt: item.sentAt as string | undefined,
    direction: (item.direction as string | undefined) ?? 'outbound',
    contactName: item.contactName as string | undefined,
  });
  return true;
}
